import { t } from '@lingui/core/macro';

export const EXPLANATION_MODAL_HEADER = (): string => t`What makes a best match?`;
export const EXPLANATION_MODAL_BUTTON_TEXT = (): string => t`Got it`;
export const EXPLANATION_MODAL_INITIAL_PARAGRAPH = (): string =>
  t`Once we know more about your request, Rover compiles a list of sitters who are very likely to be the best fit for your pet's needs and accept your request. We look at dates, location, availability, service preferences, pet preferences and more to create your list.`;

export const EXPLANATION_MODAL_PARAGRAPH_WITH_LINK = (isInEurope: boolean): string =>
  isInEurope
    ? t`All pet care providers who sign up on Rover pass <0>ID verification</0>.`
    : t`All pet care providers who sign up on Rover pass <0>a background check</0>.`;
